(function($) {
mobileSidebar = function() {
	$(window).click(function(){
      $(".mobile-sidebar").hide();
    });

    $(".mobile-sidebar-toggle").click(function(e) {
      e.stopPropagation();
        if ($(".mobile-sidebar").css("display") === "none") {
            $(".mobile-sidebar").show();
        } else {
            $(".mobile-sidebar").hide();
        }
    });

};
})(jQuery);
